import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import { toast } from 'react-toastify'
import { getAllShareLinks, getAllShareLinksFiles } from '../../core/_requests'
import ShareDrawerTableRow from './ShareDrawerTableRow'
import { Spinner } from '../../../widgets/components/General/Spinner'
import NoDataPage from '../../../widgets/components/NoDataPage'
import { useMoveToFolderData } from '../../core/FileToFolderAuth'
import { useInvestorDatabase } from '../../../investor-database/core/InvestorContext'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'

export const ShareDrawer = ({ dataRoomId, contentId }: any) => {
  const { setBlockOutsideClick } = useInvestorDatabase()
  const {
    setShareLinkApiLoading,
    setShareLinkApiData,
    shareLinkApiLoading,
    shareLinkApiData,
    setCreateLinkDrawer,
    shareDrawer,
    setShareDrawer,
  } = useMoveToFolderData()
  const { formatMessage } = useIntl()

  const getAllShareLinksByDataRoomId = async () => {
    try {
      setShareLinkApiLoading(true)
      if (dataRoomId) {
        const {
          data: { data, success, errors },
        } = await getAllShareLinks(+dataRoomId)
        if (success) {
          setShareLinkApiData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      } else {
        if (contentId) {
          const {
            data: { data, success, errors },
          } = await getAllShareLinksFiles(contentId)
          if (success) {
            setShareLinkApiData(data)
          } else {
            errors.forEach((error: string) => {
              toast.error(formatMessage({ id: error }))
            })
          }
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setShareLinkApiLoading(false)
    }
  }

  useEffect(() => {
    getAllShareLinksByDataRoomId()
  }, [dataRoomId, contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleCreateLinkClick = () => {
    setCreateLinkDrawer(true)
  }
  const onShareLinkClose = () => {
    setShareDrawer(false)
    setBlockOutsideClick(false)
  }
  useEffect(() => {
    if (shareDrawer) {
      setBlockOutsideClick(true)
    }
  }, [shareDrawer]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      id='kt_share'
      className={shareDrawer ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'}
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '735px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_share_toggle'
      data-kt-drawer-close='#kt_share_close'
    >
      <div className='share-drawer-wrapper card shadow-none rounded-0 w-100'>
        <div
          className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
          id='kt_share_header'
        >
          <div className='d-flex flex-row align-items-center mb-3 mb-md-0 w-md-auto w-100'>
            <button
              type='button'
              className='btn p-0 btn-active-light-primary me-4 '
              onClick={onShareLinkClose}
            >
              <img src={crossIcon} alt=''></img>
            </button>
            <div className='d-flex flex-row  justify-content-between justify-content-md-start justify-content-md-between flex-grow-1 flex-md-grow-0'>
              <h3 className='drawer-head-title  mb-0 me-4 text-dark'>
                {dataRoomId
                  ? formatMessage({ id: 'Share this Dataroom' })
                  : formatMessage({ id: 'Share this File' })}
              </h3>

              <div style={{ marginTop: '8px' }}>
                {dataRoomId ? (
                  <ToolTipUIForModal
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.DATAROOM.SHARE_DRAWER',
                    })}
                  />
                ) : (
                  <ToolTipUIForModal
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.DATAROOM.FILES.SHARE_DRAWER',
                    })}
                  />
                )}
              </div>
            </div>
          </div>

          <button
            onClick={handleCreateLinkClick}
            className='btn bg-primary font-size-13 flex-grow-1 flex-md-grow-0 text-white font-weight-400 height-36 d-flex align-items-center justify-content-center custom-button-property'
          >
            {formatMessage({ id: 'Create Link' })}
          </button>
        </div>

        <div className='share-drawer-body px-5 py-4 p-md-7 position-relative' id='kt_share_body'>
          <div
            id='kt_share_scroll'
            className='w-100 d-flex flex-column align-items-center mb-5 mt-2 activity-container-n overflow-visible'
          >
            <div className='d-flex flex-column flex-md-row w-100'>
              <>
                {shareLinkApiLoading ? (
                  <Spinner />
                ) : shareLinkApiData && shareLinkApiData.length === 0 ? (
                  <NoDataPage flex={true} />
                ) : (
                  <table className='d-flex flex-column gap-5'>
                    <thead>
                      <tr className=' border-bottom'>
                        <th className='title w-200px'>{formatMessage({ id: 'Account' })}</th>
                        <th className='link w-325px'>{formatMessage({ id: 'Link' })}</th>
                        <th className='w-150px'>
                          <div className='share-flex-wrapper action flex-grow-1 flex-md-grow-0 title'>
                            {formatMessage({ id: 'Actions' })}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {shareLinkApiData.map((item: any, index: number) => (
                        <ShareDrawerTableRow
                          data={item}
                          key={index}
                          getAllShareLinksByDataRoomId={getAllShareLinksByDataRoomId}
                          dataRoomId={dataRoomId}
                          contentId={contentId}
                        />
                      ))}
                    </tbody>
                  </table>
                )}
              </>
            </div>
          </div>
        </div>

        {/* begin::Footer */}

        <div className='share-drawer-footer d-flex justify-content-end ' id='kt_footer'>
          <button onClick={onShareLinkClose} className='btn btn-light flex-grow-1 flex-md-grow-0  '>
            {formatMessage({ id: 'Cancel' })}
          </button>
        </div>
        {/* end::Footer */}
      </div>
    </div>
  )
}
